export default {
  data: () => ({
    translations: {
      search: {
        el: 'Αναζήτηση',
        en: 'Search',
        it: 'Cerca',
      },
      searchBy: {
        el: '',
        en: 'Search by ',
        it: '',
      },
      generalSettings: {
        el: 'Γενικές Ρυθμίσεις',
        en: 'General Settings',
        it: 'Impostazioni Generali',
      },
      billingDashboard: {
        el: 'Πίνακας Ελέγχου Τιμολόγησης',
        en: 'Billing Dashboard',
        it: 'Dashboard di Fatturazione',
      },
      subscriptionInactiveErrorPart1: {
        el: 'Έχετε μια ανενεργή συνδρομή. Μεταβείτε στον "',
        en: 'You have an inactive subscription. Please go to "',
        it: 'Hai un abbonamento inattivo. Vai a "',
      },
      subscriptionInactiveErrorPart2: {
        el: 'Πίνακα ελέγχου τιμολόγησης',
        en: 'Billing Dashboard',
        it: 'Dashboard di fatturazione',
      },
      subscriptionInactiveErrorPart3: {
        el: '" για να τον ενεργοποιήσετε.',
        en: '" to activate it.',
        it: '" per attivarlo.',
      },
      subscriptionCancelledErrorPart1: {
        el: 'Η συνδρομή σας έχει ακυρωθεί και θα παραμείνει ενεργή μέχρι ',
        en: 'Your subscription has been cancelled and will remain active until ',
        it: 'La tua sottoscrizione è stata annullata e rimarrà attiva fino al ',
      },
      developers: {
        el: 'Προγραμματιστές',
        en: 'Developers',
        it: 'Sviluppatori',
      },
      totalNoOfChars: {
        el: 'Συνολικός αριθμός χαρακτήρων',
        en: 'Total Number Of Characters',
        it: 'Numero totale di caratteri',
      },
      totalNoOfSms: {
        el: 'Συνολικός αριθμός SMS',
        en: 'Total Number Of SMS',
        it: 'Numero totale di SMS',
      },
      updateAll: {
        el: 'Ανανέωση όλων',
        en: 'Update All',
        it: 'Aggiorna tutto',
      },
      selectAll: {
        el: 'Επιλογή όλων',
        en: 'Select All',
        it: 'Seleziona tutti',
      },
      sessionExpired: {
        el: 'Η συνεδρία έληξε, παρακαλώ συνδεθείτε εκ νέου',
        en: 'Session expired, please log in anew.',
        it: 'Sessione scaduta, effettuare un nuovo accesso',
      },
      invalidCredentials: {
        el: 'Λανθασμένα στοιχεία σύνδεσης.',
        en: 'Invalid login credentials.',
        it: 'Credenziali di accesso non valide.',
      },
      whoops404: {
        el: 'Ουπς, 404',
        en: 'Whoops, 404',
        it: 'Oops, 404',
      },
      pageNotExists: {
        el: 'Η σελίδα που ψάχνετε δεν υπάρχει',
        en: 'The page you were looking for does not exist',
        it: 'La pagina cercata non esiste',
      },
      getMeOuttaHere: {
        el: 'Βγάλτε με από εδώ!',
        en: 'get me out of here!',
        it: 'portami fuori di qui!',
      },
      goBack: {
        el: 'Επιστροφή!',
        en: 'Go back!',
        it: 'Indietro!',
      },
      noRights: {
        el: 'Δεν έχετε τα δικαιώματα πρόσβασης σε αυτή τη σελίδα.',
        en: 'You don’t have the rights to access this resource.',
        it: 'Non hai i diritti per accedere a questa risorsa.',
      },
      deleteCompany: {
        en: 'Delete Company',
        el: 'Διαγραφή Εταιρίας',
        it: 'Elimina azienda',
      },
      delete: {
        en: 'Delete',
        el: 'Διαγραφή',
        it: 'Elimina',
      },

      deleteCompanyConfirmationMessage: {
        el: 'Σίγουρα θέλεις να διαγράψεις την παρακάτω εταιρία;',
        en: 'Are you sure you want to delete the following company?',
        it: 'È sicuro di voler eliminare la seguente azienda?',
      },

      name: {
        el: 'Όνομα',
        en: 'Name',
        it: 'Nome',
      },

      address: {
        el: 'Διεύθυνση',
        en: 'Address',
        it: 'Indirizzo',
      },

      primary_phone: {
        el: 'Τηλέφωνο',
        en: 'Primary Phone',
        it: 'Telefono',
      },
      subscribed: {
        el: 'Συνδρομή',
        en: 'Subscribed',
        it: 'Abbonati',
      },
      companyDeletedNotif: {
        el: `H Εταιρεία διαγράφηκε επιτυχώς.
                Aνακατεύθυνση στην σελίδα σύνδεσης καταστήματος...`,
        en: `Company Deleted Successfully.
                Redirecting to store login page...`,
        it: `Azienda cancellata con successo. 
                Reindirizzamento alla pagina di login del negozio...`,
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
      profile: {
        el: 'Προφίλ',
        en: 'Profile',
        it: 'Profilo',
      },
      logout: {
        el: 'Αποσύνδεση',
        en: 'Logout',
        it: 'Disconnessione',
      },
      download: {
        el: 'κατεβάσετε',
        en: 'download',
        it: 'scarica',
      },
      exportReady: {
        el: (fileName) => `Το αρχείο “${fileName}” είναι έτοιμο, μπορείτε να το `,
        en: (fileName) => `The file “${fileName}” is ready, you can `,
        it: (fileName) => `Il file “${fileName}” è pronto, puoi `,
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
    },
  }),
};
